import { render, staticRenderFns } from "./PaymentRemittanceDeleteHistoryList.vue?vue&type=template&id=660f2209&scoped=true&"
import script from "./PaymentRemittanceDeleteHistoryList.vue?vue&type=script&lang=js&"
export * from "./PaymentRemittanceDeleteHistoryList.vue?vue&type=script&lang=js&"
import style0 from "./PaymentRemittanceDeleteHistoryList.vue?vue&type=style&index=0&id=660f2209&lang=scss&scoped=true&"
import style1 from "./PaymentRemittanceDeleteHistoryList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660f2209",
  null
  
)

export default component.exports